// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSideDrawers_container__lJVLt"};